export const handleShowChurchill = (sid: string) => {
  switch (sid) {
    case 'ctm':
    case 'msm':
    case 'confused':
    case 'quotezone':
      return true
    default:
      return false
  }
}
